export default [
  {
    id: "a",
    description:
      "Rooms, parts of buildings or buildings where; sleeping facilities are available, occupants may be restricted in their movement, the number of occupants and access to the space is not regulated and occupants are not acquainted with the necessary safety precautions.",
    example:
      "Public buildings such as hospitals, courts or prisons, theatres, supermarkets, schools, lecture halls, public transport termini, hotels, dwellings, restaurants."
  },
  {
    id: "b",
    description:
      "Rooms, parts of buildings or buildings where there is limited access to a limited number of people, some of whom are acquainted with the general safety precautions of the establishment.",
    example:
      "Business or professional offices, laboratories, places for general manufacturing or more generally facilities where people work that are closed to the public."
  },
  {
    id: "c",
    description:
      "Rooms, parts of buildings or buildings where only authorized access is allowed. Occupants of the establishment where manufacturing, processing or storage of material or products take place are acquainted with general and special safety precautions within the space.",
    example:
      "Manufacturing facilities, e.g. for chemicals, food, beverage, ice, ice-cream, refineries, cold stores, dairies, industrial food preparation facilities, non-public areas in supermarkets."
  }
];
